import { getMaxSuffix } from './name'


export function getUniqueDatasetName (
  baseName: string,
  names: string[],
): string {
  // Clean up the names by removing '-a', '-b', and numeric suffixes
  const cleanedNames = names.map(v => v
    .replace(/-(\d)[ab]$/, '-$1')
    .replace(/-(a|b)$/, ''))

  // Check if baseName exists without any suffix
  const nameExists = cleanedNames.includes(baseName)

  // Get the highest numeric suffix using getMaxSuffix
  const maxSuffix = getMaxSuffix(baseName, cleanedNames)

  // If baseName exists without numeric suffix, return baseName-2
  // If no suffixes exist, return baseName directly, otherwise, increment the highest suffix
  const name = (!nameExists && maxSuffix === 0) || maxSuffix === undefined
    ? baseName // If baseName exists without numeric suffix, return baseName-2
    : `${baseName}-${maxSuffix === 0 ? maxSuffix + 2 : maxSuffix + 1}` // Otherwise, increment the highest suffix

  return name
}


export function getDatasetSplitName (
  name: string,
  suffix: string,
): string {
  return name
    .trim()
    .replace(/-(\d+)$/, `-$1${suffix}`) // Convert '-number' to '-<number>suffix'
    .replace(/(^[\w\s]+$)/, `$1-${suffix}`) // Append '-suffix' if there's no suffix
}
